import React from "react";
import { Link } from "react-router-dom";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="ink-info-page ink-info-page--returns">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">We&apos;ll help make it right</p>
          <h1>Returns &amp; Refunds</h1>
          <p className="ink-info-page__lead">
            If you are not happy with your purchase, contact ioomparade so a
            return and refund can be arranged.
          </p>
        </header>

        <section className="returns-window" aria-labelledby="returns-window-title">
          <div className="returns-window__number" aria-hidden="true">30</div>
          <div>
            <p className="ink-info-page__kicker">Return window</p>
            <h2 id="returns-window-title">30 days after purchase</h2>
            <p>
              Return requests must be made within 30 days of the purchase date.
              Please get in touch before sending an item back so the next steps
              can be arranged.
            </p>
          </div>
          <Link className="ink-info-page__button" to="/contact">
            Start a return
          </Link>
        </section>

        <section className="returns-steps" aria-labelledby="returns-steps-title">
          <div className="returns-steps__intro">
            <p className="ink-info-page__kicker">Simple next steps</p>
            <h2 id="returns-steps-title">How to request a return</h2>
          </div>
          <ol>
            <li>
              <span>01</span>
              <h3>Contact ioomparade</h3>
              <p>
                Send your order details and a short explanation through the
                contact page.
              </p>
            </li>
            <li>
              <span>02</span>
              <h3>Arrange the return</h3>
              <p>
                ioomparade will help arrange the refund and confirm what should
                happen next.
              </p>
            </li>
            <li>
              <span>03</span>
              <h3>Send it back when required</h3>
              <p>
                For a preference-based return, the recipient is responsible for
                shipping the item back.
              </p>
            </li>
          </ol>
        </section>

        <section className="returns-issues" aria-labelledby="returns-issues-title">
          <div>
            <p className="ink-info-page__kicker">Order issue?</p>
            <h2 id="returns-issues-title">Mistake or error in your order</h2>
          </div>
          <p>
            If ioomparade made a mistake or there is an error in your order,
            please let us know. The team will do its best to fix the problem.
          </p>
        </section>

        <p className="returns-source-note">
          Need delivery information instead? <Link to="/shipping">View shipping details</Link>.
        </p>
      </div>
    </main>
  );
}

export default Returns;
